import { Box, Typography, Container } from '@mui/material';
import { styled } from '@mui/system';
import CardCertificate from './CardCertificate';

export default function Certificates({ certificateData }) {
  if (!certificateData) {
    console.log('no certificateData');
    return null;
  }

  return (
    <Container>
      <Typography variant="h2" sx={{ marginBottom: '20px' }}>Zertifikate</Typography>
      <CardContainer sx={
        certificateData.length >= 3
          ? { justifyContent: 'space-between' }
          : { justifyContent: 'flex-start' }
      }
      >
        {certificateData.map((certficate, index) => (
          <CardCertificate
            key={index}
            certficate={certficate}
          />
        ))}
      </CardContainer>
    </Container>
  );
}

// Styling
const CardContainer = styled(Box, {})({
  display: 'flex',
  paddingLeft: 0,

  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 24,
  alignItems: 'top',
});
